<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/lcwpInsurance/findInsuranceWithdrawRecord.action"
                        ref="insuranceWithdrawTable">
            <template slot="search">
                <el-date-picker
                        @change="onDateTimeChange"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        style="margin-left:10px;"
                        type="datetimerange"
                        v-model="queryParams.startEndTime">
                </el-date-picker>
                <el-input placeholder="单号/姓名/电话" style="margin-left:10px;width:230px;"
                          v-model="queryParams.keyword"></el-input>
                <el-button @click="$refs['insuranceWithdrawTable'].search()" style="margin-left:10px;" type="primary">
                    搜索
                </el-button>
            </template>
            <template slot="item">
                <el-table-column
                        label="提现单号"
                        prop="withdrawNumber">
                </el-table-column>
                <el-table-column
                        label="姓名"
                        prop="name">
                </el-table-column>
                <el-table-column
                        label="账号"
                        prop="phone">
                </el-table-column>
                <el-table-column
                        label="来源渠道"
                        prop="channelName">
                </el-table-column>
                <el-table-column
                        label="提现账户"
                        prop="aliPay">
                </el-table-column>
                <el-table-column
                        label="兑换绿豆奖励(个)"
                        prop="count">
                    <template slot-scope="scope">
                        <span v-if="scope.row.count">
                          {{scope.row.count}}
                       </span>
                        <span v-else>{{(scope.row.money)*10 + 30}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="金额(元)"
                        prop="money">
                </el-table-column>
                <el-table-column
                        label="审核状态"
                        prop="status">
                    <template scope="scope">
                        {{scope.row.status| authStatusFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="支付状态"
                        prop="payStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status!==3">
                          {{scope.row.payStatus| payStatusFilter}}
                       </span>
                        <span style="color: red;" v-else>无需打款</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime">
                    <template scope="scope">
                        {{scope.row.createTime | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">
                        <el-button :confirm-data="{id:scope.row.id,status:2,loginUserName:loginInfo.realName}"
                                   @onConfirm="$refs['insuranceWithdrawTable'].loadList()"
                                   confirm-text="请确认你的审核操作是否无误？"
                                   confirm-title="提现审核后不能逆转，请二次确认！"
                                   requestUrl="lcwpInsurance/authInsuranceWithdraw.action"
                                   style="color:#0084f5"
                                   type="text"
                                   v-confirm
                                   v-if="scope.row.status===1">通过
                        </el-button>
                        <el-button :confirm-data="{id:scope.row.id,status:3,loginUserName:loginInfo.realName}"
                                   @onConfirm="$refs['insuranceWithdrawTable'].loadList()"
                                   confirm-text="请确认你的审核操作是否无误？"
                                   confirm-title="提现审核后不能逆转，请二次确认！"
                                   requestUrl="lcwpInsurance/authInsuranceWithdraw.action"
                                   style="color:#0084F5"
                                   type="text"
                                   v-confirm
                                   v-if="scope.row.status===1">拒绝
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'insuranceWithdraw',
  data: function () {
    return {
      queryParams: {}
    }
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs['insuranceWithdrawTable'].search()
    }
  },
  filters: {
    payStatusFilter (value) {
      // '支付状态:1-提现成功；2-提现失败;3-提现正在处理',
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '提现成功'
          break
        case 2:
          filterValue = '提现失败'
          break
        case 3:
          filterValue = '提现正在处理'
          break
      }
      return filterValue
    },
    authStatusFilter (value) {
      // 状态:1-待审核2-审核通过 3-审核不通过
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '待审核'
          break
        case 2:
          filterValue = '审核通过'
          break
        case 3:
          filterValue = '审核不通过'
          break
      }
      return filterValue
    }
  }
}
</script>

<style scoped>

</style>
